module.exports = __webpack_public_path__ + "img/bj40.4525315d.png";